import { createI18n } from 'vue-i18n';

// 1. 自動掃描所有的 .json 檔案
const modules = import.meta.glob('./**/*.{json,ts}', { eager: true });

const messages: Record<string, any> = {};

// 2. 解析路徑並自動合併成命名空間
Object.keys(modules).forEach((path) => {
    // 修正 Regex 以同時匹配 .json 或 .ts
    const matched = path.match(/\/([^/]+)\/([^/]+)\.(json|ts)$/);

    if (matched && matched.length === 4) {
        const locale = matched[1];     // zh-TW
        const moduleName = matched[2];  // common / login / primevue
        const content = (modules[path] as any).default;

        if (!messages[locale]) {
            messages[locale] = {};
        }

        // 合併內容
        messages[locale][moduleName] = content;
    }
});

// 3. 初始語系:優先讀 localStorage(使用者上次的選擇),沒有或非法則用預設。
//    支援語系直接取自掃描到的 messages(多一個語系資料夾即自動納入,免改此處)。
const SUPPORT_LOCALES = Object.keys(messages);
const DEFAULT_LOCALE = 'zh-TW';

const getInitialLocale = (): string => {
    const saved = localStorage.getItem('locale');
    return saved && SUPPORT_LOCALES.includes(saved) ? saved : DEFAULT_LOCALE;
}

export const i18n = createI18n({
    legacy: false,
    locale: getInitialLocale(),
    fallbackLocale: 'en-US',
    globalInjection: true,
    messages
});

/**
 * 設定網頁標題(document.title)。標題內容來自 i18n,故統一於此(router 導航與元件切語系共用,
 * 避免組字邏輯重複)。格式:有頁面標題時為「頁面標題 - 應用名稱」,否則僅應用名稱。
 * @param titleKey 當前路由的 meta.titleKey(i18n key);無則只顯示應用名稱。
 */
export const setDocumentTitle = (titleKey?: string): void => {
    const { t } = i18n.global;
    const appName = t('app.title');
    const pageTitle = titleKey ? t(titleKey) : '';
    document.title = pageTitle ? `${pageTitle} - ${appName}` : appName;
}

export default i18n;